<template>
	<!-- 龙虎斗游戏组件 -->
	<div class="Dragon_Tiger_box cf" v-if="gameid == 93">
		<!--  dragon_select -->
		<a
			class="dragon_itembox_big"
			v-for="(item, index) in gameary"
			:key="index"
			:data-state="item.state"
			@click="selectGame"
			:data-index="index"
		>
			<h3 :class="[item.state == 'true' ? 'dragon_select big_icon' : '']">{{ item.name }}</h3>
		</a>
	</div>
	<div class="Dragon_Tiger_box cf" v-else>
		<!--  dragon_select -->
		<a
			class="dragon_itembox"
			v-for="(item, index) in gameary"
			:key="index"
			:data-state="item.state"
			@click="selectGame"
			:data-index="index"
		>
			<h3
				:class="[item.state == 'true' ? item.selectNav : item.unselectNav, item.state == 'true' ? 'dragon_select' : '']"
			>
				{{ item.name }}
			</h3>
			<p>￥{{ item.odds }}</p>
		</a>
	</div>
</template>
<script>
export default {
	props: {
		gameary: {
			type: Array,
			required: true,
		},
		gameid: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			selectAry: [], //选择玩法后返回父组件数组
		};
	},
	methods: {
		// 选中龙虎斗数组
		selectGame(e) {
			let that = this;
			let indexs = e.currentTarget.dataset.index;
			let sta = e.currentTarget.dataset.state;
			if (sta == "false") {
				that.gameary[indexs].state = "true";
				that.selectAry.push(that.gameary[indexs].name);
			} else if (sta == "true") {
				that.gameary[indexs].state = "false";
				let ids = that.selectAry.indexOf(that.gameary[indexs].name);
				if (ids > -1) {
					that.selectAry.splice(ids, 1);
				}
			}
			this.$emit("setdata", that.selectAry);
			this.setNum();
		},
		//设置注数
		setNum() {
			this.$emit("setbet", this.selectAry.length);
		},
	},
};
</script>
<style>
.Dragon_Tiger_box {
	width: 100%;
	padding: 15px 20px 0 13px;
	display: flex;
	flex-wrap: wrap;
}

.dragon_itembox_big > h3 {
	width: 146px;
	height: 48px;
	font-size: 24px;
	/* 	font-weight: 600; */
	font-weight: 400;
	line-height: 48px;
	text-align: center;
	font-family: PingFangSC;
	color: #888;
	border-radius: 9px;
	box-shadow: 0px 3px 9px 0 rgba(0, 0, 0, 0.15);
}
.dragon_itembox_big[data-state="true"] h3,
.dragon_itembox_big:hover h3 {
	background-color: #1e8edd;
	color: #fff;
}

.dragon_itembox,
.dragon_itembox_big {
	margin: 0 5px 15px;
	text-align: center;
	padding: 7px 0;
	cursor: pointer;
}

.dragon_itembox > h3 {
	display: flex;
	align-items: center;
	justify-content: center;
	color: #888;
	font-size: 18px;
	width: 45px;
	height: 45px;
	text-align: center;
	cursor: pointer;
	margin: 0 3px;
	border-radius: 50%;
	font-size: 26px;
	font-weight: 400;
	border: 1px solid #ccc;
}

.dragon_itembox > h3:hover {
	color: #ffffff;
	background-color: #0e78c7;
}

.dragon_itembox > h3.dragon_select {
	color: #fff;
	/* background-image: url("~@/static/img/moreNumber/n_bg.webp"); */
	background: #2794e7;
	background-size: cover;
	border: none;
}

.dragon_itembox > p {
	margin-top: 8px;
	font-size: 12px;
	color: #9b9b9b;
	font-family: "HiraginoSansGB-W3";
}
</style>



// WEBPACK FOOTER //
// src/components/Subcomponents/Dragon_Tiger.vue